
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Asset": [
      "Bollard",
      "CapBeam",
      "Pile"
    ],
    "CreateBollardDefaultPropertyResult": [
      "AlreadyExistsError",
      "BollardDefaultProperty"
    ],
    "CreateCapBeamDefaultPropertyResult": [
      "AlreadyExistsError",
      "CapBeamDefaultProperty"
    ],
    "CreateCapBeamLoadResult": [
      "AlreadyExistsError",
      "CapBeamLoad"
    ],
    "CreateCustomFieldDefinitionResult": [
      "CustomFieldDefinition",
      "DuplicateSelectOptionError"
    ],
    "CreateDocumentResult": [
      "Document",
      "MissingFileExtensionError"
    ],
    "CreateInspectionFrequencyResult": [
      "AlreadyExistsError",
      "InspectionFrequency"
    ],
    "CreateNoteResult": [
      "MissingFileExtensionError",
      "Note"
    ],
    "CreatePileDefaultPropertyResult": [
      "AlreadyExistsError",
      "PileDefaultProperty"
    ],
    "CreatePileLoadResult": [
      "AlreadyExistsError",
      "PileLoad"
    ],
    "CustomFieldValue": [
      "BooleanValue",
      "NumberValue",
      "StringValue"
    ],
    "Inspection": [
      "CapBeamInspection",
      "PileInspection"
    ],
    "InviteUserResult": [
      "AlreadyExistsError",
      "InviteUserSuccess"
    ],
    "Property": [
      "CapBeamProperty",
      "PileProperty"
    ],
    "UserError": [
      "AlreadyExistsError",
      "DuplicateSelectOptionError",
      "MissingFileExtensionError"
    ]
  }
};
      export default result;
    